<template>
  <div class="mx-auto container container--fluid">
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false" :ripple="false">Close</v-btn>
    </v-snackbar>

    <v-card class="box">
      <v-toolbar dense flat class="toolbar">
        <v-toolbar-title>Form Field Config</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>

        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn class="mb-2 mr-2 ma-4 button" v-on="on" :ripple="false">New Config</v-btn>
          </template>

          <v-card>
            <v-card-title class="toolbar">
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row dense>
                  <v-col cols="12">
                    <v-select dense outlined rounded v-model="editedItem.fieldtype" :items="field_type_list"
                      :readonly="editedIndex !== -1" item-text="fieldtype" item-value="id" label="Field Type"
                      :filled="editedIndex !== -1" :error="errorMsg.formFieldType"
                      :error-messages="errorMsg.formFieldType ? 'Required' : ''" return-object
                      :ripple="false"></v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete v-model="editedItem.field" :items="field_list" :readonly="editedIndex !== -1"
                      item-text="field" item-value="id" label="Field" outlined rounded dense multiple
                      :filled="editedIndex !== -1" :error="errorMsg.fieldName"
                      :error-messages="errorMsg.fieldName ? 'Required' : ''" return-object
                      :ripple="false"></v-autocomplete>
                  </v-col>
                  <v-col cols="12" v-if="editedIndex != -1">
                    <v-text-field label="Field Display Name" outlined dense v-model="editedItem.field_display_name" rounded></v-text-field>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="12">
                    <v-checkbox dense v-model="editedItem.iseditable" color="success" label="Is-Editable?"
                      :ripple="false"></v-checkbox>
                    <v-checkbox dense v-model="editedItem.required" color="success" label="Required?"
                      :ripple="false"></v-checkbox>
                    <v-checkbox dense v-model="editedItem.isactive" color="success" label="Active?"
                      :ripple="false"></v-checkbox>
                    <v-checkbox v-if="editedItem.fieldtype != 'Admission form'" dense v-model="editedItem.is_tab" color="success" label="Is Tab?"
                      :ripple="false"></v-checkbox>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="button" @click="close" :ripple="false">Cancel</v-btn>
              <v-btn class="button" @click="save" :ripple="false">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>

      <!-- Filter Dropdown (Same as old UI) -->
      <v-row class="ma-4" justify="center">
        <v-col cols="4">
          <v-select v-model="filters.fieldtype" :items="field_type_list" item-text="fieldtype" item-value="fieldtype"
            label="Form Field Type" outlined rounded clearable dense hide-details multiple chips small-chips></v-select>
        </v-col>
      </v-row>

      <!-- Main Table (100% same look) -->
      <v-data-table :headers="headers" :items="getFilteredItems" sort-by="fieldtype" dense class="elevation-1 mytable"
        :items-per-page="-1" show-select v-model="selected" item-key="id">
        <template v-slot:item.iseditable="{ item }">
          <span v-if="item.iseditable"><v-icon color="success">Y</v-icon></span>
          <span v-else><v-icon color="error">N</v-icon></span>
        </template>
        <template v-slot:item.required="{ item }">
          <span v-if="item.required"><v-icon color="success">Y</v-icon></span>
          <span v-else><v-icon color="error">N</v-icon></span>
        </template>
        <template v-slot:item.isactive="{ item }">
          <v-icon v-if="item.isactive" color="success">check_circle</v-icon>
          <v-icon v-else color="error">cancel</v-icon>
        </template>
        <template v-slot:item.is_tab="{ item }">
          <v-icon v-if="item.is_tab" color="success">check_circle</v-icon>
          <v-icon v-else color="error">cancel</v-icon>
        </template>

        <template v-slot:item.action="{ item }">
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-avatar size="25" class="edit-avatar">
                <v-icon class="edit-v-icon" color="primary" @click="editItem(item)" v-on="on" :ripple="false">edit</v-icon>
              </v-avatar>
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-avatar size="25" class="edit-avatar">
                <v-icon class="edit-v-icon" color="error" @click="showDeleteDialog(item)" v-on="on" :ripple="false">delete</v-icon>
              </v-avatar>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </template>

        <!-- Bulk Edit Pencil Icon -->
        <template v-slot:header.data-table-select="{ on, props }">
          <div class="d-flex align-center">
            <v-simple-checkbox v-bind="props" v-on="on" color="primary" :ripple="false"></v-simple-checkbox>
            <span v-if="selected.length" class="ml-2 text-caption">{{ selected.length }} selected</span>
            <v-btn v-if="selected.length > 0" icon medium color="primary" class="ml-2" @click.stop="openBulkEditDialog"
              :ripple="false">
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
            <!-- NEW: Bulk Delete Trash Icon -->
            <v-btn v-if="selected.length > 0" icon small color="error" class="ml-1" @click.stop="openBulkDeleteDialog"
              :ripple="false">
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- BULK EDIT DIALOG - EXACTLY LIKE SINGLE EDIT (JUST FOR MULTIPLE ROWS) -->
    <v-dialog v-model="bulkEditDialog" max-width="600px">
      <v-card>
        <v-card-title class="toolbar">
          Bulk Edit — {{ selected.length }} Item(s) Selected
        </v-card-title>

        <v-card-text class="pt-4">
          <v-container>
            <div class="mb-4">
              <strong>Selected Fields ({{ selected.length }}):</strong>
              <div class="mt-2" style="max-height: 200px; overflow-y: auto;">
                <v-chip v-for="item in selected" :key="item.id" small color="primary" close close-icon="mdi-close"
                  @click:close="removeFromSelection(item)" class="ma-1">
                  {{ item.field_display_name || item.field }}
                </v-chip>
              </div>
            </div>

            <v-row>
              <v-col cols="12">
                <v-checkbox v-model="bulkValues.iseditable" label="Is Editable?" color="success" dense></v-checkbox>
              </v-col>
              <v-col cols="12">
                <v-checkbox v-model="bulkValues.required" label="Required?" color="success" dense></v-checkbox>
              </v-col>
              <v-col cols="12">
                <v-checkbox v-model="bulkValues.isactive" label="Active?" color="success" dense></v-checkbox>
              </v-col>
              <v-col cols="12">
                <v-checkbox v-model="bulkValues.is_tab" label="Show as Tab?" color="success" dense></v-checkbox>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="bulkEditDialog = false">Cancel</v-btn>
          <v-btn color="primary" @click="applyBulkEdit">Apply Changes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Bulk Delete Dialog -->
    <v-dialog v-model="bulkDeleteDialog" max-width="500px">
      <v-card>
        <v-card-title class="toolbar">
          <span class="headline">Confirm Bulk Delete</span>
        </v-card-title>

        <v-card-text class="pt-5">
          <div class="body-1">
            Are you sure you want to delete {{ selected.length }} selected configuration(s)?
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="button" @click="bulkDeleteDialog = false" :ripple="false">
            Cancel
          </v-btn>
          <v-btn color="error" dark @click="confirmBulkDelete" :ripple="false"> Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Delete Dialog (unchanged) -->
    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-card>
        <v-card-title class="toolbar">Confirm Delete</v-card-title>
        <v-card-text>Are you sure you want to delete this configuration?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="deleteDialog = false" :ripple="false">Cancel</v-btn>
          <v-btn color="error" @click="confirmDelete" :ripple="false">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
    components: {
        Breadcrumbs,
    },
        data: () => ({
            // fieldsforsearch: ["Gender", "Standred", "First name", "Last name", "Middle name", "Birth Place", "Date of Birth", "Family income", "Prizes", "Domacile", "Category"],
            errorMsg: {
                formFieldType: false,
                fieldName: false,
            },
            snackbar_msg: "",
            // extraBreadcrumbItems: [
             

            // ],
            // breadcrumbClass: "breadcrumb-style1",
            color: "",
            snackbar: false,
            search: "",
            load: false,
            dialog: false,
            deleteDialog: false,
          bulkEditDialog: false,
          bulkDeleteDialog: false,
          bulkValues: {
            iseditable: false,
            required: false,
            isactive: true,
            is_tab: false
          },
            field_config_list: null,
            field_type_list: null,
            field_list: null,
             filterArr: [],
             filters: {
                fieldtype: [],
                
            },
            headers: [
                { text: "Form Field Type", value: "fieldtype" },
                { text: "Field Name", value: "field" },
                { text: "Field Display Name", value: "field_display_name" },
                { text: "Is-Editable?", value: "iseditable" },
                { text: "Is-Compulsory?", value: "required" },
                { text: "Active", value: "isactive" },
                { text: "Is Tab ?", value: "is_tab" },
                { text: "Actions", value: "action", sortable: false },
            ],

            editedIndex: -1,
            editedItem: {
                id: "",
                fieldtype: "",
                field: "",
                iseditable: true,
                isactive: true,
                is_tab: true,
                required: true,
            },
            defaultItem: {
                id: "",
                fieldtype: "",
                field: "",
                iseditable: true,
                isactive: true,
                 is_tab: true,
                required: true,
            },
             itemToDelete: null,
             selected: [],
        }),

        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "New Config" : "Edit Config";
            },
        //      getFilteredItems() {
        //               return this.field_config_list.filter((d) => {
        //                 return Object.keys(this.filters).every((f) => {
        //                      return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
        //                      });
        //         });
        //  },
            getFilteredItems() {
      if (!this.field_config_list) return [];
      const filtered = this.field_config_list.filter(item =>
        Object.keys(this.filters).every(key =>
          this.filters[key].length === 0 || this.filters[key].includes(item[key])
        )
      );
      this.selected = this.selected.filter(s => filtered.some(f => f.id === s.id));
      return filtered;
    },
     },

        watch: {

          'editedItem.fieldtype'(val) {
            if (val === 'Admission form') {
              this.editedItem.is_tab = false
            }
          },


            dialog(val) {
                val || this.close();
            },
             deleteDialog(val) {
                if (!val) this.itemToDelete = null;
            },
        },
        mounted() {
            this.onload();
        },

        methods: {
          columnValueList(val) {
            return this.field_config_list.map((d) => d[val]);
          },
          openBulkEditDialog() {
            if (this.selected.length === 0) return;

            // Set checkboxes to the value of the FIRST selected item
            const first = this.selected[0];
            this.bulkValues = {
              iseditable: first.iseditable,
              required: first.required,
              isactive: first.isactive,
              is_tab: first.is_tab
            };

            this.bulkEditDialog = true;
          },

          isIndeterminate(field) {
            if (!this.selected.length) return false;
            const values = this.selected.map(i => i[field]);
            return !values.every(v => v === values[0]);
          },
          removeFromSelection(itemToRemove) {
            // Remove from selected array
            this.selected = this.selected.filter(item => item.id !== itemToRemove.id);

            // Optional: Show small feedback
            if (this.selected.length === 0) {
              this.bulkEditDialog = false; // close dialog if nothing left
              this.showSnackbar("#ff9800", "All items removed from selection");
            }
          },
          applyBulkEdit() {
            const updates = {
              iseditable: this.bulkValues.iseditable,
              required: this.bulkValues.required,
              isactive: this.bulkValues.isactive,
              is_tab: this.bulkValues.is_tab
            };

            Promise.all(
              this.selected.map(item =>
                axios.post("/admission/editFormFieldConfig", { ...item, ...updates })
              )
            )
              .then(() => {
                // UPDATE TABLE IMMEDIATELY — Vue reactivity safe
                this.selected.forEach(item => {
                  Object.assign(item, updates);  // This updates the actual row object
                });

                // this.selected = [];  // clear selection
                this.bulkEditDialog = false;

                this.showSnackbar("#4caf50", `Successfully updated !!`);
              })
              .catch(err => {
                console.error(err);
                this.showSnackbar("#b71c1c", "Bulk update failed");
              });
          },
          openBulkDeleteDialog() {
      if (this.selected.length === 0) return;
      this.bulkDeleteDialog = true;
    },

    confirmBulkDelete() {
      const idsToDelete = this.selected.map(item => item.id);

      Promise.all(
        idsToDelete.map(id =>
          axios.post("/admission/deleteFormFieldConfig", { id })
        )
      )
      .then(() => {
        // Remove from local list
        this.field_config_list = this.field_config_list.filter(
          item => !idsToDelete.includes(item.id)
        );
        this.selected = [];
        this.bulkDeleteDialog = false;
        this.showSnackbar("#4caf50", `Successfully deleted ${idsToDelete.length} item(s)`);
      })
      .catch(err => {
        console.error(err);
        this.showSnackbar("#b71c1c", "Bulk delete failed");
      });
    },
            onload() {
                axios
                    .post("/admission/formFieldConfig")
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.field_config_list = res.data.field_config_list;
                            this.field_type_list = res.data.field_type_list;
                            this.field_list = res.data.field_list;
                            this.load = true;
                        } else {
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
            },
            initializeErrorMsgFalse() {
                this.errorMsg.formFieldType = false;
                this.errorMsg.fieldName = false;
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            editItem(item) {
                this.editedIndex = this.field_config_list.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            },
            showDeleteDialog(item) {
                console.log("Item to delete:", item);
                this.itemToDelete = item;
                this.deleteDialog = true;
            },
           confirmDelete() {
                if (!this.itemToDelete || !this.itemToDelete.id) {
                    this.showSnackbar("#b71c1c", "No item selected for deletion");
                    this.deleteDialog = false;
                    return;
                }
                console.log("Deleting item with payload:", { id: this.itemToDelete.id });
                axios
                    .post("/admission/deleteFormFieldConfig", { id: this.itemToDelete.id }, {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.field_config_list = this.field_config_list.filter(
                                (item) => item.id !== this.itemToDelete.id
                            );
                            this.showSnackbar("#4caf50", "Form Field Config Deleted Successfully...");
                            this.onload();
                        } else {
                            this.showSnackbar("#b71c1c", "Failed to Delete Form Field Config");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Error Deleting Form Field Config");
                        window.console.log(error);
                    })
                    .finally(() => {
                        this.deleteDialog = false;
                        this.itemToDelete = null;
                    });
            },
            close() {
                this.dialog = false;
                this.initializeErrorMsgFalse();
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                }, 300);
            },

            save() {
                if (this.editedIndex > -1) {
                    if (this.isValidated()) {
                        //  console.log("edit.." + this.editedItem);

                        axios
                            .post("/admission/editFormFieldConfig", this.editedItem)
                            .then((res) => {
                                if (res.data.msg == "200") {
                                    Object.assign(this.field_config_list[this.editedIndex], this.editedItem);
                                    this.showSnackbar("#4caf50", "Form Field Config Updated Successfully..."); // show snackbar on success
                                    this.onload();
                                }
                            })
                            .catch((error) => {
                                window.console.log(error);
                            });

                        this.close();
                    }
                } else {
                    if (this.isValidated()) {
                        axios
                            .post("/admission/saveFormFieldConfig", this.editedItem)
                            .then((res) => {
                                if (res.data.flag == "Yes") {
                                    this.field_config_list.push(this.editedItem);
                                    this.showSnackbar("#4caf50", "Form Field Config Added Successfully..."); // show snackbar on success
                                    this.onload();
                                } else if (res.data.status.code == "NA") {
                                    this.showSnackbar("#b71c1c", "Form Field Config Already Present!!!"); // show snackbar on error
                                    this.onload();
                                }
                            })
                            .catch((error) => {
                                window.console.log(error);
                            });

                        this.close();
                    }
                }
            }, // end of save()

            isValidated() {
                if (this.editedItem.fieldtype && this.editedItem.field) {
                    return true;
                } else {
                    if (!this.editedItem.fieldtype) {
                        this.errorMsg.formFieldType = true;
                    }
                    if (!this.editedItem.field) {
                        this.errorMsg.fieldName = true;
                    }
                    return false;
                }
            },
        },
    };
</script>
<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }
    .v-icon-size {
        font-size: 20px;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        /* padding-left: 6px; */
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
</style>
<!-- abcd -->
